import React, { Component } from "react";
import { Form, Checkbox } from "react-form";

import InputText from "components/form-fields/InputText";
import ImageField from "components/form-fields/ImageField";

export default class extends Component {
  constructor(props) {
    super(props);
    this.removedImages = { logo: undefined };
  }

  onSubmit = data => {
    const { uploadedImages } = this.props;

    if (uploadedImages) {
      const shapedImagesStructure = Object.keys(uploadedImages).reduce(
        (result, key) => {
          result[key] = uploadedImages[key].data.file;
          return result;
        },
        {}
      );
      data = Object.assign({}, data, this.removedImages, shapedImagesStructure);
    }
    this.props.handleFormSubmit(data);
  };

  urlValidator(value) {
    const regx = /^[a-z0-9]+(?:-+[a-z0-9]+)*$/;
    const message =
      "must be lowercase and may only contain letters, numbers, and separating words with dashes.";
    return {
      error: value && !regx.exec(value) ? message : null
    };
  }

  onClickRemove = name => event => {
    this.props.removeUploadedImage(name);
    this.removedImages = Object.assign(
      this.removedImages,
      {},
      { [name]: null }
    );
  };

  onImageFieldChange = name => event => {
    const files = event.target.files || event.dataTransfer.files;
    if (!files[0]) return;

    const photo = new Image();
    photo.onload = () => {
      const data = new FormData();
      data.append("file", files[0]);
      this.props.uploadImage(name, data).then(() => {
        this.props.setUploadedImagePreview(name, photo.src);
      });
    };
    photo.src = window.URL.createObjectURL(files[0]);
  };

  render() {
    const {
      onClickRemove,
      onImageFieldChange,
      props: { defaultValues, uploadedImagesPreview, uploadedImagesPercentage }
    } = this;

    console.log(defaultValues);
    return (
      <Form onSubmit={this.onSubmit} defaultValues={defaultValues}>
        {formApi => (
          <form onSubmit={formApi.submitForm}>
            <div className="box">
              <div className="columns">
                <div className="column">
                  <ImageField
                    field="logo"
                    label="Logo"
                    uploadPercentage={uploadedImagesPercentage.logo}
                    preview={uploadedImagesPreview.logo}
                    onChange={onImageFieldChange("logo")}
                    onClickRemove={onClickRemove("logo")}
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <InputText
                    field="title"
                    label="Title"
                    type="text"
                    placeholder="Title"
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <InputText
                    required
                    field="name"
                    label="Name"
                    placeholder="Name"
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <div
                    className="control checkbox"
                    style={{ marginRight: "10px" }}
                  >
                    <label>Online? </label>
                    <Checkbox label="Online" field="online" />
                  </div>
                </div>
              </div>
            </div>

            <button className="button is-fullwidth is-info is-medium">
              Submit
            </button>
          </form>
        )}
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/AvailableGateway/Form.js